import Drawer, { DrawerHeader } from 'common/components/drawer';

import { FormDrawer } from 'common/components/drawer';

import CreateForm from './CreateForm';
import EditForm from './EditForm';

const Form = ({ drawer, active, refetchData }) => {
  return (
    <Drawer layout="table" {...drawer}>
      <DrawerHeader className="border-bottom pb-4">
        {active ? 'Edit User' : 'Add New User'}
      </DrawerHeader>

      <FormDrawer>
        {active ? (
          <EditForm
            refetchData={refetchData}
            isOpen={drawer.isOpen}
            drawer={drawer}
            active={active}
          />
        ) : (
          <CreateForm refetchData={refetchData} isOpen={drawer.isOpen} drawer={drawer} />
        )}
      </FormDrawer>
    </Drawer>
  );
};

export default Form;
